export default {
  name: 'EplNewPaymentSummaryCard',
  props: ['payableAmount']
}



// WEBPACK FOOTER //
// ./src/components/EplNewPaymentSummaryCard/component.js